<template>
    
    <div id="wrapper" v-if="$route.meta.layout === 'main'">
        <Sidebar
            :is-open="sidebarOpen"
            :collapsed="sidebarCollapsed"
            @close="sidebarOpen = false"
        ></Sidebar>
        <div id="content-wrapper" class="d-flex flex-column" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
            <div id="content">
                <Navbar
                    :sidebar-open="sidebarOpen"
                    :sidebar-collapsed="sidebarCollapsed"
                    @toggle-sidebar="sidebarOpen = !sidebarOpen"
                    @toggle-sidebar-collapse="sidebarCollapsed = !sidebarCollapsed"
                />

                <Toast ref="toast"/>

                <main class="page-content">
                    <router-view/>
                </main>
            </div>
        </div>
    </div>

    <div class="login-layout" v-if="$route.meta.layout === 'login'">
        <router-view/>
    </div>

    <div class="container" v-if="$route.meta.layout === 'quiz-active'">
        <router-view/>
    </div>


</template>

<script>

import Navbar from "@/pages/layout/Navbar.vue";
import Sidebar from "@/pages/layout/Sidebar.vue";

export default {
    name: 'App',
    components: {
        Navbar, Sidebar
    },
    data() {
        return {
            sidebarOpen: false,
            sidebarCollapsed: false
        }
    },
    watch: {
        '$route.path'() {
            this.sidebarOpen = false
        }
    }
}
</script>

<style>

@import './styles/sb-admin-2.css';

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    color: #2c3e50;
}

.login-layout {
    background-color: #f0f2f5;
    min-height: 100vh;
}

#content-wrapper {
    padding-top: 0;
}

#content {
    padding: 0;
}

.page-content {
    /* The navbar is fixed, so the scrollable page needs its own safe offset. */
    min-height: 100vh;
    padding: 5.875rem 1.5rem 1.5rem;
}

#content-wrapper.sidebar-collapsed {
    margin-left: 72px;
}

@media (max-width: 768px) {
    #content-wrapper.sidebar-collapsed {
        margin-left: 0;
    }
}

</style>
